import {
  buildNormalizedDay,
  buildNormalizedPilotBlueprint,
  localizedGenderNode,
} from "./referenceNormalizerPilotUtils";

/** Required substring for scripts/validate_dna_blueprints.mjs (runtime writing steps). */
export const DNA_VALIDATE_WRITING_PHRASE = "אני שואל/ת את עצמי בשקט";

const days = [
  {
    dayNumber: 1,
    emotionalStage: "pause",
    title: "Ponerle nombre (sin discutir con ello)",
    opening: localizedGenderNode(
      [
      "Hoy no intento demostrar que soy suficiente. Solo reconozco la frase que vuelve — y me quedo conmigo."
    ],
      [
      "Hoy no intento demostrar que soy suficiente. Solo reconozco la frase que vuelve — y me quedo conmigo."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo conmigo.",
      "Una respiración lenta.",
      "En mi interior: “Esta es la voz de ‘no soy suficiente’. No soy yo.”"
    ],
      [
      "Me detengo conmigo.",
      "Una respiración lenta.",
      "En mi interior: “Esta es la voz de ‘no soy suficiente’. No soy yo.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Cuál es la frase exacta que aparece hoy? (“No soy suficiente porque…”)",
      "¿Dónde lo siento en el cuerpo? (pecho / abdomen / garganta / cabeza)",
      "¿Cuándo es más fuerte? (mañana / trabajo / relaciones / amigos / redes)"
    ],
      [
      "¿Cuál es la frase exacta que aparece hoy? (“No soy suficiente porque…”)",
      "¿Dónde lo siento en el cuerpo? (pecho / abdomen / garganta / cabeza)",
      "¿Cuándo es más fuerte? (mañana / trabajo / relaciones / amigos / redes)"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "Hoy no derroto la voz. Solo la ilumino.",
      "Pequeña acción para hoy"
    ],
      [
      "Cierre",
      "Hoy no derroto la voz. Solo la ilumino.",
      "Pequeña acción para hoy"
    ]
    ),
    action: localizedGenderNode(
      "Una vez hoy: una respiración + la frase: “Es una voz. No es un hecho.”",
      "Una vez hoy: una respiración + la frase: “Es una voz. No es un hecho.”"
    ),
  },
  {
    dayNumber: 2,
    emotionalStage: "pain",
    title: "Hecho vs. interpretación (CBT suave)",
    opening: localizedGenderNode(
      [
      "Hoy separo lo que ocurrió de lo que mi mente dice que significa sobre mí."
    ],
      [
      "Hoy separo lo que ocurrió de lo que mi mente dice que significa sobre mí."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo conmigo.",
      "Una respiración. “La verdad no tiene que doler así.”"
    ],
      [
      "Me detengo conmigo.",
      "Una respiración. “La verdad no tiene que doler así.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Cuál es el hecho concreto que ocurrió? (2 líneas, sin interpretación)",
      "¿Qué interpretación apareció de inmediato? (“Significa que yo…”)",
      "¿Cuál es una verdad alternativa y suave que también es posible?"
    ],
      [
      "¿Cuál es el hecho concreto que ocurrió? (2 líneas, sin interpretación)",
      "¿Qué interpretación apareció de inmediato? (“Significa que yo…”)",
      "¿Cuál es una verdad alternativa y suave que también es posible?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "No toda interpretación es verdad. A veces es miedo intentando protegerme.",
      "Pequeña acción para hoy"
    ],
      [
      "Cierre",
      "No toda interpretación es verdad. A veces es miedo intentando protegerme.",
      "Pequeña acción para hoy"
    ]
    ),
    action: localizedGenderNode(
      "Una vez hoy: “Hecho ≠ interpretación.” Luego una respiración.",
      "Una vez hoy: “Hecho ≠ interpretación.” Luego una respiración."
    ),
  },
  {
    dayNumber: 3,
    emotionalStage: "pain",
    title: "El crítico interno (separar “yo” del “crítico”)",
    opening: localizedGenderNode(
      [
      "Hoy identifico quién habla: yo — o mi crítico interno."
    ],
      [
      "Hoy identifico quién habla: yo — o mi crítico interno."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo conmigo.",
      "Una respiración. “El crítico es un mecanismo, no una identidad.”"
    ],
      [
      "Me detengo conmigo.",
      "Una respiración. “El crítico es un mecanismo, no una identidad.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué me dice hoy el crítico?",
      "Si el crítico fuera un personaje — ¿cómo se vería o sonaría?",
      "¿Qué le diría a un amigo querido en mi lugar?"
    ],
      [
      "¿Qué me dice hoy el crítico?",
      "Si el crítico fuera un personaje — ¿cómo se vería o sonaría?",
      "¿Qué le diría a un amigo querido en mi lugar?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "No tengo que hablarme con un tono que me debilita.",
      "Pequeña acción para hoy"
    ],
      [
      "Cierre",
      "No tengo que hablarme con un tono que me debilita.",
      "Pequeña acción para hoy"
    ]
    ),
    action: localizedGenderNode(
      "Cuando aparezca el crítico: “Hola, crítico. Te escucho.” Y vuelvo a la respiración.",
      "Cuando aparezca el crítico: “Hola, crítico. Te escucho.” Y vuelvo a la respiración."
    ),
  },
  {
    dayNumber: 4,
    emotionalStage: "pattern",
    title: "¿Dónde aprendí “no soy suficiente”? (raíz suave, sin hurgar)",
    opening: localizedGenderNode(
      [
      "Hoy veo dónde empezó — para que deje de sentirse como verdad absoluta."
    ],
      [
      "Hoy veo dónde empezó — para que deje de sentirse como verdad absoluta."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo conmigo.",
      "Una respiración. “Lo que aprendí antes no tiene que gobernar mi vida hoy.”"
    ],
      [
      "Me detengo conmigo.",
      "Una respiración. “Lo que aprendí antes no tiene que gobernar mi vida hoy.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Cuándo me sentí “no suficiente” por primera vez, que recuerde?",
      "¿Qué necesitaba entonces y no recibí? (aprobación / calidez / ser visto / protección)",
      "¿Qué frase quiero decirle hoy a mi yo más joven?"
    ],
      [
      "¿Cuándo me sentí “no suficiente” por primera vez, que recuerde?",
      "¿Qué necesitaba entonces y no recibí? (aprobación / calidez / ser visto / protección)",
      "¿Qué frase quiero decirle hoy a mi yo más joven?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "El dolor es real — pero no prueba que yo sea menos.",
      "Pequeña acción para hoy"
    ],
      [
      "Cierre",
      "El dolor es real — pero no prueba que yo sea menos.",
      "Pequeña acción para hoy"
    ]
    ),
    action: localizedGenderNode(
      "Una frase para mí: “Era niño/a. Hice lo mejor que pude.”",
      "Una frase para mí: “Era niño/a. Hice lo mejor que pude.”"
    ),
  },
  {
    dayNumber: 5,
    emotionalStage: "pattern",
    title: "Comparación con otros (volver la medida hacia mí)",
    opening: localizedGenderNode(
      [
      "Hoy dejo de medirme en relación con otros."
    ],
      [
      "Hoy dejo de medirme en relación con otros."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo conmigo.",
      "Una respiración. “La comparación es dolor disfrazado.”"
    ],
      [
      "Me detengo conmigo.",
      "Una respiración. “La comparación es dolor disfrazado.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Con quién me he estado comparando últimamente y en qué área?",
      "¿Qué me digo que eso significa sobre mí?",
      "¿Qué cosa verdadera sobre mí no entra en esta comparación?"
    ],
      [
      "¿Con quién me he estado comparando últimamente y en qué área?",
      "¿Qué me digo que eso significa sobre mí?",
      "¿Qué cosa verdadera sobre mí no entra en esta comparación?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "No nací para vencer a otros. Nací para ser yo.",
      "Pequeña acción para hoy"
    ],
      [
      "Cierre",
      "No nací para vencer a otros. Nací para ser yo.",
      "Pequeña acción para hoy"
    ]
    ),
    action: localizedGenderNode(
      "Hoy hago una “pausa de comparación”: respiración + “vuelvo a mí”.",
      "Hoy hago una “pausa de comparación”: respiración + “vuelvo a mí”."
    ),
  },
  {
    dayNumber: 6,
    emotionalStage: "fear",
    title: "Recibir un cumplido sin huir",
    opening: localizedGenderNode(
      [
      "Hoy practico recibir lo bueno sin encogerme."
    ],
      [
      "Hoy practico recibir lo bueno sin encogerme."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo conmigo.",
      "Una respiración. “Tengo permiso para recibir.”"
    ],
      [
      "Me detengo conmigo.",
      "Una respiración. “Tengo permiso para recibir.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Cómo suelo responder a los cumplidos? (minimizo / bromeo / desvío / cambio tema)",
      "¿Qué me asusta de recibir un cumplido?",
      "¿Cuál es una respuesta simple y sana? (por ejemplo: “Gracias”)"
    ],
      [
      "¿Cómo suelo responder a los cumplidos? (minimizo / bromeo / desvío / cambio tema)",
      "¿Qué me asusta de recibir un cumplido?",
      "¿Cuál es una respuesta simple y sana? (por ejemplo: “Gracias”)"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "Recibir un cumplido no es arrogancia. Es respeto propio.",
      "Pequeña acción para hoy"
    ],
      [
      "Cierre",
      "Recibir un cumplido no es arrogancia. Es respeto propio.",
      "Pequeña acción para hoy"
    ]
    ),
    action: localizedGenderNode(
      "Si alguien dice algo bueno — respondo solo: “Gracias.”",
      "Si alguien dice algo bueno — respondo solo: “Gracias.”"
    ),
  },
  {
    dayNumber: 7,
    emotionalStage: "need",
    title: "Un pequeño experimento (conductual): actuar a pesar de la voz",
    opening: localizedGenderNode(
      [
      "Hoy hago algo pequeño aunque la voz diga “no soy suficiente”."
    ],
      [
      "Hoy hago algo pequeño aunque la voz diga “no soy suficiente”."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo conmigo.",
      "Una respiración. “No necesito sentirme suficiente para actuar.”"
    ],
      [
      "Me detengo conmigo.",
      "Una respiración. “No necesito sentirme suficiente para actuar.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué acción pequeña evito por “no ser suficiente”?",
      "¿Cuál es una versión del 10% de esa acción?",
      "¿Qué quiero demostrarme a mí con ese 10%?"
    ],
      [
      "¿Qué acción pequeña evito por “no ser suficiente”?",
      "¿Cuál es una versión del 10% de esa acción?",
      "¿Qué quiero demostrarme a mí con ese 10%?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "Mi valor no depende de un resultado perfecto — depende de ser leal a mí.",
      "Pequeña acción para hoy"
    ],
      [
      "Cierre",
      "Mi valor no depende de un resultado perfecto — depende de ser leal a mí.",
      "Pequeña acción para hoy"
    ]
    ),
    action: localizedGenderNode(
      "Hago mi 10%. Eso es todo.",
      "Hago mi 10%. Eso es todo."
    ),
  },
  {
    dayNumber: 8,
    emotionalStage: "softening",
    title: "Incomodidad permitida (ACT): sostener “menos que” por un minuto",
    opening: localizedGenderNode(
      [
      "Hoy practico quedarme con la sensación un minuto — sin arreglarla."
    ],
      [
      "Hoy practico quedarme con la sensación un minuto — sin arreglarla."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo conmigo.",
      "Una respiración. “Una sensación es una ola, no un veredicto.”"
    ],
      [
      "Me detengo conmigo.",
      "Una respiración. “Una sensación es una ola, no un veredicto.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Cuál es el disparador más fuerte de “no soy suficiente”?",
      "Práctica de un minuto: dejo que la sensación esté — sin actuar.\n¿Qué pasó en mi cuerpo después del minuto?",
      "¿Qué aprendí sobre la ola?"
    ],
      [
      "¿Cuál es el disparador más fuerte de “no soy suficiente”?",
      "Práctica de un minuto: dejo que la sensación esté — sin actuar.\n¿Qué pasó en mi cuerpo después del minuto?",
      "¿Qué aprendí sobre la ola?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "Me fortalezco no porque desaparece la emoción — sino porque me quedo.",
      "Pequeña acción para hoy"
    ],
      [
      "Cierre",
      "Me fortalezco no porque desaparece la emoción — sino porque me quedo.",
      "Pequeña acción para hoy"
    ]
    ),
    action: localizedGenderNode(
      "Solo un minuto. Constancia > fuerza.",
      "Solo un minuto. Constancia > fuerza."
    ),
  },
  {
    dayNumber: 9,
    emotionalStage: "softening",
    title: "Valor personal vs. desempeño",
    opening: localizedGenderNode(
      [
      "Hoy separo quién soy de cómo me fue."
    ],
      [
      "Hoy separo quién soy de cómo me fue."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo conmigo.",
      "Una respiración. “El fracaso es un evento, no una identidad.”"
    ],
      [
      "Me detengo conmigo.",
      "Una respiración. “El fracaso es un evento, no una identidad.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Dónde confundo desempeño con valor personal?",
      "¿Qué diría si esto fuera solo un intento y no una prueba?",
      "¿Qué cosa hago bien, aunque no sea perfecta?"
    ],
      [
      "¿Dónde confundo desempeño con valor personal?",
      "¿Qué diría si esto fuera solo un intento y no una prueba?",
      "¿Qué cosa hago bien, aunque no sea perfecta?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "Puedo mejorar sin reducirme.",
      "Pequeña acción para hoy"
    ],
      [
      "Cierre",
      "Puedo mejorar sin reducirme.",
      "Pequeña acción para hoy"
    ]
    ),
    action: localizedGenderNode(
      "Una vez hoy digo: “Esto es un proceso, no una prueba.”",
      "Una vez hoy digo: “Esto es un proceso, no una prueba.”"
    ),
  },
  {
    dayNumber: 10,
    emotionalStage: "perspective",
    title: "Ser “suficiente” sin demostrar (autocompasión)",
    opening: localizedGenderNode(
      [
      "Hoy me sostengo como sostendría a alguien que amo."
    ],
      [
      "Hoy me sostengo como sostendría a alguien que amo."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo conmigo.",
      "Una respiración. “Me hablo con suavidad.”"
    ],
      [
      "Me detengo conmigo.",
      "Una respiración. “Me hablo con suavidad.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué le diría a un amigo cercano que se siente “no suficiente”?",
      "¿Qué frase de eso puedo decirme hoy?",
      "¿Dónde me cuesta más ser suave conmigo?"
    ],
      [
      "¿Qué le diría a un amigo cercano que se siente “no suficiente”?",
      "¿Qué frase de eso puedo decirme hoy?",
      "¿Dónde me cuesta más ser suave conmigo?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "La compasión no me debilita. Me devuelve fuerza.",
      "Pequeña acción para hoy"
    ],
      [
      "Cierre",
      "La compasión no me debilita. Me devuelve fuerza.",
      "Pequeña acción para hoy"
    ]
    ),
    action: localizedGenderNode(
      "Mano en el pecho o abdomen (si es cómodo) + mi frase suave una vez.",
      "Mano en el pecho o abdomen (si es cómodo) + mi frase suave una vez."
    ),
  },
  {
    dayNumber: 11,
    emotionalStage: "strength",
    title: "Límites frente a voces externas (“qué dirán”)",
    opening: localizedGenderNode(
      [
      "Hoy reduzco el ruido externo que me dirige."
    ],
      [
      "Hoy reduzco el ruido externo que me dirige."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo conmigo.",
      "Una respiración. “No necesito aprobación para existir.”"
    ],
      [
      "Me detengo conmigo.",
      "Una respiración. “No necesito aprobación para existir.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Dónde “qué dirán” me controla más?",
      "¿Cuál es el costo de vivir para la aprobación?",
      "¿Qué límite pequeño pondré esta semana?"
    ],
      [
      "¿Dónde “qué dirán” me controla más?",
      "¿Cuál es el costo de vivir para la aprobación?",
      "¿Qué límite pequeño pondré esta semana?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "Puedo escuchar a otros sin abandonarme.",
      "Pequeña acción para hoy"
    ],
      [
      "Cierre",
      "Puedo escuchar a otros sin abandonarme.",
      "Pequeña acción para hoy"
    ]
    ),
    action: localizedGenderNode(
      "Una vez hoy elijo una acción solo para mí.",
      "Una vez hoy elijo una acción solo para mí."
    ),
  },
  {
    dayNumber: 12,
    emotionalStage: "release",
    title: "Reparar el lenguaje (las palabras construyen realidad)",
    opening: localizedGenderNode(
      [
      "Hoy ajusto un tono interno — y cambia el rumbo."
    ],
      [
      "Hoy ajusto un tono interno — y cambia el rumbo."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo conmigo.",
      "Una respiración. “Las palabras son un hogar.”"
    ],
      [
      "Me detengo conmigo.",
      "Una respiración. “Las palabras son un hogar.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué palabra me pongo como etiqueta?",
      "¿Cómo suena la misma verdad en un lenguaje humano y no violento?",
      "¿Qué frase adopto para esta semana?"
    ],
      [
      "¿Qué palabra me pongo como etiqueta?",
      "¿Cómo suena la misma verdad en un lenguaje humano y no violento?",
      "¿Qué frase adopto para esta semana?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "No tengo que hablarme en un idioma de guerra.",
      "Pequeña acción para hoy"
    ],
      [
      "Cierre",
      "No tengo que hablarme en un idioma de guerra.",
      "Pequeña acción para hoy"
    ]
    ),
    action: localizedGenderNode(
      "Cada vez que detecto una palabra dura — la reemplazo una vez.",
      "Cada vez que detecto una palabra dura — la reemplazo una vez."
    ),
  },
  {
    dayNumber: 13,
    emotionalStage: "choice",
    title: "“Suficiente” como camino (no como destino)",
    opening: localizedGenderNode(
      [
      "Hoy construyo identidad de avance, no de prueba."
    ],
      [
      "Hoy construyo identidad de avance, no de prueba."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo conmigo.",
      "Una respiración. “Estoy en camino.”"
    ],
      [
      "Me detengo conmigo.",
      "Una respiración. “Estoy en camino.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué valor quiero que me guíe?",
      "¿Qué hábito pequeño apoya ese valor esta semana?",
      "¿Qué me prometo en días difíciles?"
    ],
      [
      "¿Qué valor quiero que me guíe?",
      "¿Qué hábito pequeño apoya ese valor esta semana?",
      "¿Qué me prometo en días difíciles?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "Ser suficiente no es algo que se gana. Es algo desde lo que se practica vivir.",
      "Pequeña acción para hoy"
    ],
      [
      "Cierre",
      "Ser suficiente no es algo que se gana. Es algo desde lo que se practica vivir.",
      "Pequeña acción para hoy"
    ]
    ),
    action: localizedGenderNode(
      "היום אני נשאר עם זה עוד רגע קטן.",
      "היום אני נשאר עם זה עוד רגע קטן."
    ),
  },
  {
    dayNumber: 14,
    emotionalStage: "continuation",
    title: "Cierre suave (frase de regreso para días difíciles)",
    opening: localizedGenderNode(
      [
      "Hoy termino sin “victoria”. Termino siendo fiel a mí."
    ],
      [
      "Hoy termino sin “victoria”. Termino siendo fiel a mí."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo conmigo.",
      "Una respiración. “Me quedo conmigo.”"
    ],
      [
      "Me detengo conmigo.",
      "Una respiración. “Me quedo conmigo.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué cambió en mí, aunque sea un poco? (3 cosas)",
      "¿Qué quedó más claro sobre la voz de “no soy suficiente”?",
      "Frase de regreso para días difíciles:"
    ],
      [
      "¿Qué cambió en mí, aunque sea un poco? (3 cosas)",
      "¿Qué quedó más claro sobre la voz de “no soy suficiente”?",
      "Frase de regreso para días difíciles:"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre final del viaje",
      "No borro la voz.",
      "Simplemente dejo de permitir que dirija mi vida.",
      "Sigo caminando —",
      "despacio, en silencio, conmigo.",
      "Y eso es fuerza.",
      "Pequeña acción para hoy"
    ],
      [
      "Cierre final del viaje",
      "No borro la voz.",
      "Simplemente dejo de permitir que dirija mi vida.",
      "Sigo caminando —",
      "despacio, en silencio, conmigo.",
      "Y eso es fuerza.",
      "Pequeña acción para hoy"
    ]
    ),
    action: localizedGenderNode(
      "Una acción que diga: “estoy de mi lado”.",
      "Una acción que diga: “estoy de mi lado”."
    ),
  },
].map(buildNormalizedDay);

export const iAmNotEnoughBlueprintEs = buildNormalizedPilotBlueprint({
  id: "i_am_not_enough_14d",
  version: "tri_locale_emit_es_v1",
  durationDays: 14,
  problemKey: "i_am_not_enough",
  category: "general",
  journeyName: {
    he: "תחושת “אני לא מספיק/ה”",
    en: "I’m Not Enough",
    es: "No soy suficiente",
  },
  days,
});

export default iAmNotEnoughBlueprintEs;
